import React from "react";
import { useI18n } from "Hooks";
import classes from "./UseTemplateHeader.scss";
import { ToddleIcon } from "SvgComponents";
import LockingStateLabelComponent from "AppComponents/Attachment/components/LockingStateLabelComponent";
import { ArrowOutOutlined, ChevronLeftOutlined } from "@toddle-edu/ds-icons";

const UseTemplateHeader = ({
  title,
  onClose,
  rightActionButton,
  shouldShowTabIcon,
  url,
  attachmentBottomComponent,
  showSimilarityIndex,
  attachment,
}) => {
  const { t } = useI18n(["a11y"]);
  return (
    <div className={classes.container}>
      <div className={classes.leftPanel}>
        <div className={classes.logoCon} onClick={onClose}>
          <div className={classes.chevronIconContainer}>
            <ChevronLeftOutlined size="xx-small" variant="on" />
          </div>

          <ToddleIcon width={32} height={32} />
        </div>
        <div className={classes.headerTitle}>
          <div className={classes.title}>{title}</div>
          <div className={classes.lockingText}>
            <LockingStateLabelComponent
              attachment={attachment}
              lockedVariant={"critical"}
            />
          </div>
        </div>
      </div>
      <div className={classes.rightPanel}>
        {showSimilarityIndex && (
          <div className={classes.similarityReportBorderStyle}>
            {attachmentBottomComponent()}
          </div>
        )}
        {shouldShowTabIcon && (
          <a
            className={classes.newTabIcon}
            href={url}
            rel="noopener noreferrer"
            target="_blank"
            aria-label={t("a11y:open_in_new_tab")}
          >
            <ArrowOutOutlined size="x-small" variant="on" />
          </a>
        )}
        {rightActionButton && (
          <div className={classes.turnInButtonContainer}>
            {rightActionButton}
          </div>
        )}
      </div>
    </div>
  );
};
UseTemplateHeader.defaultProps = {
  shouldShowTabIcon: true,
};

export default UseTemplateHeader;
